import { rosterAPI } from '@/providers/apis/roster/roster';
import { Vue, Component } from 'vue-property-decorator';

@Component({
    name: 'user-details',
})

export default class UserDetails extends Vue {

    // ------------------------------------------------------------------------
    // Properties
    private filter: any = null;

    private currentPage: number = 1;

    private userList: any = [];

    private datas: any = [];

    private tableFields: any = [
        { key: 'familyName', label: 'User Name', sortable: true },
        { key: 'role', label: 'Role', sortable: true },
        { key: 'email', label: 'Email', sortable: true },
        { key: 'grades', label: 'Grades', sortable: true},
        { key: 'identifier', label: 'Identifier' },
        { key: 'dateLastModified', label: 'Date of Modified' },
        { key: 'status', label: 'Status' },
    ];

    // ---------------------------------------------------------------------------------
    // Hooks

    // -----------------------------------------------------------------------------
    // Actions

    private onSelectRow(row: any) {
        this.$emit('onSelectRow', {row, content: 'user'});
    }

    private onSearchField(e: any, column: any) {
        const users = this.datas;
        this.userList = users.filter(
            (item: any) => (item[column].toLowerCase()).startsWith(e.target.value.toLowerCase()));

    }

    // ------------------------------------------------------------------------------
    // Methods

}
